const expiredbg = require('../../../shared/images/TrialExpiredbg.svg');

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';

import * as Consts from './CommonDefs';
import * as Colors from 'material-ui/styles/colors';
import Radium from 'radium';


@Radium
export default class TrialExpired extends Component {

  componentDidMount() {
    window.analytics.track('Trial Expired - Dialog');
  }

  handleClose = () => {
    const {onRequestClose} = this.props;
    onRequestClose();
  };

  render() {
    return (
      <Dialog
        id = "id dialog"
        open = {this.props.open}
        bodyStyle = {{
          backgroundImage: 'url(' + expiredbg + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          width: Consts.WIZARD_WIDTH,
          padding: 0,
          height: Consts.WIZARD_HEIGHT,
        }}
        contentStyle = {{
          maxWidth: Consts.WIZARD_WIDTH,
          width: Consts.WIZARD_WIDTH
        }}
        onRequestClose = {() => {this.handleClose();}}
      >
        <div
          style={{
            height: Consts.WIZARD_HEIGHT
          }}
        >
          <IconButton
            onClick={() => {this.handleClose();}}
            iconStyle={{color: 'grey'}}
            style = {{
              position: 'absolute',
              right: 0
            }}
          >
            <FontIcon className="material-icons" >close</FontIcon>
          </IconButton>
          <div
            style = {{
              textAlign: 'right',
              fontFamily: '"Roboto", sans-serif',
              position: 'relative',
              width: '90%',
              height: '40%',
              top: 100
            }}
          >
            <div
              style = {{
                fontSize: 50,
                fontFamily: '"Acme", sans-serif',
                color: Colors.orange800
              }}
            >
              YOUR TRIAL HAS EXPIRED
            </div>
            <div
              style = {{
                fontSize: 21,
                color: Colors.grey700,
                marginBottom: 30
              }}
            >
              Please upgrade to continue using Crazylister
            </div>
            <RaisedButton
              label = {"SELECT A PLAN"}
              onClick = {() => {
                window.analytics.track('Trial Expired - Upgrade Clicked');
                window.open('/application/user/upgrade?upgradeSrc=Trial%20Expired');
                this.handleClose();
              }}
              labelColor = {Colors.white}
              backgroundColor = {Colors.orange800}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}
